import { render } from "./goodsList.vue?vue&type=template&id=1a20ba0d"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=1a20ba0d&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__